import type { Account } from '@shared/products-types';

import { useProductData } from './useProductData';

type HookReturnType = Omit<ReturnType<typeof useProductData<Account>>, 'updateAlias'>;

export const useLoanAccount: (id: string) => HookReturnType = (id) => {
    const { isPending, error, product, refetch } = useProductData(id);

    return {
        isPending,
        error,
        refetch,
        product,
    };
};
